module.exports = {
	"appName": "ControlSmart",
	"lang": "Idioma",
	"modules": {
		"Login": "Login",
		"Workers": "Empleados",
		"WorkersNew": "Nuevo",
		"WorkersEdit": "Editar",
		"Attendance": "Asistencia",
		"workers": "Workers",
		"attendance": "Attendance",
		"finnance": "Finanzas",
		"computingMetrics": "Cubicación",
	},
	"login": {
		"welcome": "Bienvenido",
		"username": "Usuario",
		"password": "Contraseña",
		"forgotPassword": "Olvidó su contraseña?",
		"login": "Iniciar sesión"
	},
	"finnance": {
		"purchaseOrders": {
			"title": "Ordenes de compra",
			"new": "Nueva orden de compra",
			"number": "Número de orden",
			"date": "Fecha de creación",
			"dateDelivered": "Fecha entregado",
			"invoiceDate": "Fecha facturación",
			"datePaid": "Fecha de pago",
			"total": "Total",
			"subTotal": "Sub Total",
			"taxRate": "Impuesto",
			"noProducts": "No hay productos agregados a la orden de compra",
			"statuses": {
				'open': 'Abierto',
				'delivered': 'Entregado',
				'invoiced': 'Facturado',
				'paid': 'Pagado',
				'received': 'Recibido'
			}
		},
		"invoices": {
			"title": "Facturación",
			"new": "Nueva factura",
			"edit": "Editar facturación",
			"attachInvoice": "Adjuntar factura",
			"attachmentPlaceholder": "Seleccione un archivo o arrastrelo aquí...",
			"dropFilePlaceholder": "Suelte archivo aquí",
			"attachedInvoice": "Factura adjuntada",
			"number": "Número de factura",
			"attachShippingDocument": "Adjuntar guía de despacho",
			"attachedShippingDocument": "Guía de despacho adjuntada",
			"paymentDate": "Fecha de pago"
		},
		"salesOrders": "Ordenes de pago",
	},
	"worker": {
		"moduleName": "Empleados",
		"newWorker": "Nuevo",
		"list": "Lista",
		"new": "nuevo trabajador",
		"idNumber": "RUT",
		"firstName": "Nombre",
		"lastName": "Apellido",
		"email": "Correo electrónico",
		"phoneNumber": "Número de teléfono",
		"birthDate": "Fecha de nacimiento",
		"workerStatus": "Estado del trabajador",
		"name": "Nombre",
		"showAdvancedDetails": "Más información",
		"status": {
			"active": "Activo",
			"inactive": "Inactivo",
		}
	},
	"attendance": {
		"moduleName": "Asistencia",
		"newAttendance": "Nuevo",
		"new": "nueva asistencia",
		"checkInTime": "Hora de entrada",
		"checkOutTime": "Hora de salida",
		"permit": "Permiso",
	},
	"computingMetrics": {
		"title": "Cubicaciones",
		"new": "Nueva cubicación",
		"list": "Lista",
		"documentTitle": "Título del documento",
		"layerName": "Nombre de capa",
		"upload": "Cargar documento",
		"selectedFile": "Archivo seleccionado",
		"placeholder": "Ningún archivo seleccionado",
		"export": "Exportar",
		"type": "Tipo de cubicación"
	},
	"costCenter": {
		"new": "Nuevo centro de costo",
		"administrator": "Administrador de obra"
	},
	"contract": {
		"title": "Contrato",
		"type": "Tipo",
		"startDate": "Fecha de inicio",
		"endDate": "Fecha de término",
		"salary": "Salario",
		"position": "Cargo",
		"costCenter": "Centro de costo"
	},
	"common": {
		"noDateSelected": "No se ha seleccionado fecha",
		"more": "Más",
		"less": "Menos",
		"open": "Abrir",
		"close": "Cerrar",
		"actions": "Acciones",
		"search": "Buscar",
		"logout": "Cerrar sesión",
		"profile": "Perfil",
		"list": "Lista",
		"loading": "Cargando información",
		"for": "Para",
		"status": "Estado",
		"notAvailable": "N/A",
		"index": "índice"
	},
	"buttons": {
		"save": "Guardar",
		"cancel": "Cancelar",
		"today": "Hoy",
		"reset": "Reiniciar",
		"close": "Cerrar",
		"new": "Nuevo",
		"loadMore": "Más registros",
		"get": "Obtener",
		"print": "Imprimir",
		"back": "Volver",
		"invoice": "Facturar"
	},
	"settings": {
		"positions": "Cargos",
		"settings": "Configuración",
		"costCenterNew": "Nuevo",
		"costCenter": {
			"new": "Nuevo centro de costo",
			"title": "Centro de costos",
			"code": "Código",
			"name": "Nombre",
			"startDate": "Fecha de inicio",
			"endDate": "Fecha de término"
		},
		"contracts": {
			"title": "Contratos",
			"new": "Nuevo contrato",
			"name": "Nombre",
			"sequence": "Secuencia"
		},
		"providers": {
			"title": "Proveedores",
			"label": "Proveedor",
			"new": "Nuevo proveedor",
			"idNumber": 'RUT',
			"name": 'Nombre',
			"code": 'Código',
			"address": 'Dirección',
			"contactName": 'Nombre del contacto',
			"contactEmail": 'Correo del contacto',
			"contactTitle": 'Cargo del contacto',
			"totalCredit": 'Crédito otorgado',
			"noMaterials": 'No hay materiales asignados',
			"providerName": "Nombre del proveedor",
			"materials": {
				"title": "Materiales",
				"code": "Código",
				"name": "Nombre",
				"price": "Precio",
				"uom": "Unidad de medida",
				"active": "Activo",
				"quantity": "Cantidad",
				"quantityInvoiced": "Cantidad facturada	",
				"material": "Material"
			}
		},
		"materials": {
			"title": "Materiales",
			"new": "Nuevo material",
			"uom": "Unidad",
			"name": "Nombre",
			"codigo": "Codigo",
			"price": "Precio",
		}
	},
	"datepicker": {
		"arrowKeys": "Usar flechas para moverse por las fechas",
		"labelPrevDecade": "Década anterior",
		"labelPrevYear": "Año anterior",
		"labelPrevMonth": "Mes anterior",
		"labelCurrentMonth": "Mes actual",
		"labelNextMonth": "Mes siguiente",
		"labelNextYear": "Año siguiente",
		"labelNextDecade": "Década siguiente",
	},
	"errors": {
		"invoiceDate": "Fecha de facturación es inválida",
		"errorLabel": "Se han producido algunos errores al momento de realizar el proceso de guardado",
		"invalidAttendance": "Hay uno o más trabajadores que ya fueron registrados",
		"invoiceDocument": "Factura no adjuntada",
		"invoiceNumber": "Número de factura es inválido",
		"minimunProductsInvoiced": "Debe haber al menos un producto facturado para generar la factura",
		"shippingDocument": "Guía de despacho no adjuntada",
		"quantityInvoiced": "La cantidad facturada no puede ser mayor a la cantidad solicitada en la orden de compra",
		"zeroQuantityInvoiced": "La cantidad facturada debe ser mayor a 0"
	},
	"weekDays": ['Lun','Mar','Mie','Jue','Vie','Sab','Dom'],
	"months": ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre','Diciembre']
}